<template>
  <div class="container">
    <div v-if="!isReady"><AlertLoading /></div>
    <div v-else>
      <div class="row d-flex justify-content-center">
        <div class="col-sm-12 col-md-10 col-xl-7">
          <div class="mb-5 text-start">
            <div class="h2 fw-bold">Welcome to the House Competition</div>

            <p class="fst-italic">
              Earn achievements, boost your House, and rise to the top.
            </p>

            <p>
              Your knowledge and participation earn achievements you can show
              off while helping your House climb the leaderboard. Every badge
              you unlock adds to your personal points and contributes to your
              House’s total throughout the course.
            </p>

            <div class="fs-3 mb-3">How It Works</div>

            <div class="fs-4 mb-1">
              <i class="bi bi-patch-check-fill text-primary"></i> Complete
              Course Achievements
            </div>
            <p>
              Most achievements are tied to topics in your course. Test your
              knowledge, complete the quiz, and unlock its badge.
            </p>

            <div class="fs-4 mb-1">
              <i class="bi bi-star-fill text-warning"></i> Earn Points
            </div>
            <p>
              Each achievement you earn adds to your personal point total and
              expands your collection of badges. Your points also contribute to
              your House’s overall points.
            </p>

            <div class="fs-4 mb-1">
              <i class="bi bi-house-up-fill text-success"></i> Boost Your House
            </div>
            <p>
              You’ve been assigned to a House with other students. The more
              achievements your House members earn, the higher your team climbs
              on the leaderboard.
            </p>
          </div>

          <div class="mb-5">
            <UserCard
              :userId="getUserId"
              :fullname="getFullname"
              :userImage="getUserImage"
            >
              <div class="d-flex justify-content-end">
                <div class="me-4">
                  You are a member of<br />
                  <span class="fs-3 fw-bold">{{ getMyGroup.name }}</span>
                </div>
                <div class="my-auto d-none d-md-block">
                  <GroupIcon :index="getMyGroup.index" width="60px" />
                </div>
              </div>
            </UserCard>
          </div>

          <RouterButton
            to="Home"
            label="Go to the House Competition"
            icon="arrow-right"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLoading from "@/components/core/AlertLoading.vue";
import UserCard from "@/components/activity/UserCard.vue";
import GroupIcon from "@/components/activity/GroupIcon.vue";
import RouterButton from "@/components/activity/RouterButton.vue";

import { mapGetters, mapActions } from "vuex";
import { requestTokenAfterCanvas } from "@/admin/admin.js";
import { readEntry } from "@/apis/datastore.js";
import { readGroups } from "@/apis/group.js";
import DatastoreAPI from "@/helpers/DatastoreAPI";

export default {
  name: "LandingView",
  components: {
    AlertLoading,
    UserCard,
    GroupIcon,
    RouterButton
  },
  mixins: [DatastoreAPI],
  data() {
    return {
      isReadyGroup: false,
      isReadyEntry: false
    };
  },
  computed: {
    ...mapGetters([
      "getIssuer",
      "getFullname",
      "getCanvasImage", // from hash
      "getCanvasUserId", // from hash
      "mapToDatastore",
      "getUserId",
      "getUserImage",
      "getCourseId",
      "getCanvasCourseId",
      "getDecodedToken"
    ]),
    ...mapGetters("groups", ["getMyGroup"]),
    isReady() {
      return this.isReadyEntry && this.isReadyGroup;
    }
  },
  methods: {
    ...mapActions([
      "setCanvasUserImage",
      "setCanvasId",
      "setUserImage",
      "setCourseId",
      "mapFromDatastore"
    ]),
    ...mapActions("groups", ["setGroups"])
  },
  mounted() {
    if (this.getIssuer === "osuassignment") {
      requestTokenAfterCanvas();
    } else {
      let isChanged = false;
      readEntry().then((response) => {
        //restore from datastore
        this.setEntry(response.data.message.entry.value);
        this.mapFromDatastore(response.data.message.entry.value);

        if (this.getCanvasImage) {
          this.setUserImage(this.getCanvasImage);
          isChanged = true;
        }

        if (this.getCanvasUserId) {
          this.setCanvasId(this.getCanvasUserId);
          isChanged = true;
        }

        if (this.getCanvasCourseId) {
          this.setCourseId(this.getCanvasCourseId);
          isChanged = true;
        }

        // write to datastore
        if (isChanged) {
          this.updateEntry(this.mapToDatastore);
        }

        this.isReadyEntry = true;

        readGroups().then((payload) => {
          this.setGroups(payload.data.message.groups);
          this.isReadyGroup = true;
        });
      });
    }
  }
};
</script>
